module.exports = __webpack_public_path__ + "img/tab_short_active.c3a9e4f2.png";